import shopifySparkGenericDefaults from '../shopify-spark-generic/config.js';
import {
  isOnAnyStep as isOnAnyPackageStep,
  isOnSecondPLPStep as isOnSecondPLPPackageStep,
  vehicleWidgetRedirectUrl as vehicleWidgetPackagesRedirectUrl,
  AfterInit as packagesAfterInit,
  onVehicleSelected as packagesOnVehicleSelected,
  onVehicleDiscarded as packagesOnVehicleDiscarded,
  Widgets as packagesWidgets,
} from './liftKitPackages.js';
import {
  handleArrows,
  wheelScrollEvent,
  mouseDownEvent,
  mouseMoveEvent,
  mouseUpEvent,
  mouseLeaveEvent,
  clickEvent,
  collapseMobileContent,
} from './headerFacetEvents.js';
import { createVehicleLandingSync } from './vehicleLandingSync.js';

window.Convermax.handleArrows = (e, isLeftArrow) => handleArrows(e, isLeftArrow);
window.Convermax.handleMouseDownEvent = (e) => mouseDownEvent(e);
window.Convermax.handleMouseMoveEvent = (e) => mouseMoveEvent(e);
window.Convermax.handleMouseUpEvent = () => mouseUpEvent();
window.Convermax.handleMouseLeaveEvent = (e) => mouseLeaveEvent(e);
window.Convermax.handleClickEvent = (e) => clickEvent(e);
window.Convermax.handleWheelScrollEvent = (e) => wheelScrollEvent(e);
window.Convermax.handleCollapseMobileContent = (e) => collapseMobileContent(e);

const isOnPLPorPDP =
  window.location.pathname === '/pages/search' ||
  window.location.pathname.includes('/collections') ||
  window.location.pathname.includes('/products/');
const isOnHomePage = window.location.pathname === '/';

shopifySparkGenericDefaults.Widgets.find(
  (w) => w.name === 'HeaderVehicleWidget',
).doNotRedirectOnVehicleSelect = isOnPLPorPDP;

const wheelsFields = shopifySparkGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields;
const tiresFields = shopifySparkGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields;

const ignoreFields = [
  ...shopifySparkGenericDefaults.Widgets.find((w) => w.name === 'FilterChips').ignoreFields,
  'LiftKitProductID',
  'WheelProductID',
];

const headerFacetPanelFields = ['custom_height_ranges', 'diameter', 'vendor'];

const syncLandingVehicle = createVehicleLandingSync(['Year', 'Make', 'Model']);

function AfterInit() {
  packagesAfterInit?.();
  syncLandingVehicle();
}

const onVehicleSelected = () => {
  packagesOnVehicleSelected();
};
const onVehicleDiscarded = () => {
  packagesOnVehicleDiscarded();
};

export default {
  includes: ['shopify-spark-generic'],
  ...shopifySparkGenericDefaults,
  AfterInit,
  infiniteScrollEnabled: false,
  fitmentSearch: {
    ...shopifySparkGenericDefaults.fitmentSearch,
    forceVehicleSelection: isOnSecondPLPPackageStep,
    forceVehicleSelectionInterval: 0,
    onVehicleSelected,
    onVehicleDiscarded,
  },
  collapsibleAnimationTime: 100,
  page: {
    ...shopifySparkGenericDefaults.page,
    getPageType: (defaults) =>
      window.document.querySelector('#cm-collection-list, #cm-brand-list') ? 'parts' : defaults.getter(),
  },
  pagination: {
    centralRange: window.innerWidth < 640 ? 1 : 2,
  },
  facets: {
    ...shopifySparkGenericDefaults.facets,
    toggleFacet: [{ fields: ['fast_shipping'], term: 'True' }],
  },
  Widgets: [
    ...shopifySparkGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchBoxDialogButton',
          'FacetBarWheels',
          'FacetBarTires',
          'VerifyFitment',
          'VehicleWidgetDialog',
          'FacetDialog',
          'FilterChips',
          'Facets',
        ].includes(w.name),
    ),
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertAfter: '.halo-header-mobile',
        class: 'cm_desktop-hide',
      },
      template: 'searchBox/dialogButtonAdaptable',
      onDropdownItemsReceived: shopifySparkGenericDefaults.Widgets.find((w) => w.name === 'SearchBox')
        .onDropdownItemsReceived,
    },
    {
      name: 'HeaderBottomVehicleWidget',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-ymm-header',
        class: 'cm_vehicle-widget__header-container',
      },
      columnBreakpoint: 830,
      isAutoVehicleSelectionDisabled: true,
      template: 'fitmentSearch/headerVehicleWidget',
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetDialog',
      template: 'CustomFacetDialog',
      initCollapsed: window.Convermax.config?.facetDialogInitCollapsed ?? true,
      ignoreFields: ['custom_height_ranges'],
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields: [...ignoreFields, 'custom_height_ranges'],
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'HeaderFacetPanelContainer',
      type: 'SearchPage',
      location: '#cm-facets-header',
      template: 'HeaderFacetPanelContainer',
    },
    {
      name: 'HeaderFacetPanel',
      type: 'FacetPanel',
      fields: headerFacetPanelFields,
      showAllAlways: true,
    },
    {
      name: 'FitmentTableMobile',
      type: 'FitmentTable',
      location: '#cm-fitment-table-mobile',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect: !isOnHomePage && isOnPLPorPDP && !isOnAnyPackageStep,
      globalVehicleDiscardEnabled: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled: true,
      redirectUrl: vehicleWidgetPackagesRedirectUrl,
    },
    ...packagesWidgets,
  ],
};
